import React  from "react";

function Steps() {
  return (
    <>
      <div className="step" id="how-to-donate">
        <img src="images/map.png" className="map" alt="" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 text-center">
              <div className="section-head">
                <h3
                  className="subtitle wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  How It Works
                </h3>
                <h2
                  className="title wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  It's Really Easy!
                </h2>
                <p
                  className="text wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  We distribute your cryptocurrency to impact communities and
                  help drive the real-world utility of crypto. Follow 3 simple
                  easy steps
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div
              className="col-xl-4 col-lg-6 text-center wow fadeInUp"
              data-wow-duration="0.3s"
              data-wow-delay="0.3s"
            >
              <div className="step-box">
                <h6 className="top">STEP 1</h6>
                <div className="thumb">
                  <img src="images/step-1.png" alt="" />
                </div>
                <h3 className="subtitle">Donate Crypto</h3>
                <p className="text">
                  We receive the donations and provide receipts to donors
                </p>
              </div>
            </div>
            <div
              className="col-xl-4 col-lg-6 text-center wow fadeInUp"
              data-wow-duration="0.4s"
              data-wow-delay="0.4s"
            >
              <div className="step-box">
                <h6 className="top">STEP 2</h6>
                <div className="thumb">
                  <img src="images/step-2.png" alt="" />
                </div>
                <h3 className="subtitle">We Distribute It</h3>
                <p className="text">
                  We make direct cash transfers to those in need.
                </p>
              </div>
            </div>
            <div
              className="col-xl-4 col-lg-6 text-center wow fadeInUp"
              data-wow-duration="0.5s"
              data-wow-delay="0.5s"
            >
              <div className="step-box">
                <h6 className="top">STEP 3</h6>
                <div className="thumb">
                  <img src="images/step-3.png" alt="" />
                </div>
                <h3 className="subtitle">Empower People</h3>
                <p className="text">
                  People use the funds in their local economy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Steps;
